import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { industryAnalysisActions } from '../../../store/industryAnalysisStore';
import { industryAnalysisReportType, IndustryAnalysisReportTable, IndustryAnalysisReportTableBodyItem } from './industryAnalysisClass';
import { isNullOrUndefined, isEmpty } from '../../../store/storeFunctions';
import { Translate } from 'react-localize-redux';
import ExcelExportButton from '../../common/excelExportButton';
import HorizontalScrollControl from '../../layoutItems/horizontalScrollControl';
import NoDataComponent from '../../common/noDataComponent';

import '../../../css/search/search.scss';
import './industryAnalysis.scss';

class IndustryAnalysisStructuralIndicatorsResult extends React.Component {
    get result() {
        return this.props.industryAnalysis;
    }

    render() {
        return (
            <div className='card card-special' >
                <div className='card-body'>
                    {this.renderTable()}
                    <ExcelExportButton industryAnalysis={{ year: this.props.year, okec: this.props.nace, type: "si" }} />
                </div>
            </div>
        )
    }

    renderTable = () => {
        if (this.result.isLoading)
            return <Circles />

        if (isNullOrUndefined(this.props.year) || isNullOrUndefined(this.props.nace) || isNullOrUndefined(this.result.data))
            return (<NoDataComponent />);

        const hasData = !isNullOrUndefined(this.result.data) &&
            (!isEmpty(this.result.data.assets) || !isEmpty(this.result.data.liabilities) || !isEmpty(this.result.data.profitAndLoss));
        const { year, header, labels, assets, liabilities, profitAndLoss } = this.result.data;
        const headerData = new IndustryAnalysisReportTable(industryAnalysisReportType.structuralIndicators, year, header, labels);

        return (
            <>
                <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                    <h5 className="underlined-title rb-header">
                        <Translate id="IndustryAnalysis.StructuralIndicators" options={{ renderInnerHtml: true }} />
                        {`: ${this.result.data.okec} - ${this.result.data.title} (${year})`}
                    </h5>
                </span>
                <HorizontalScrollControl>
                    <table className="table table-report-section-2-industry-analysis without-hover w-100">
                        <tbody><tr><th colSpan="13" className="result-table-title"><Translate id="IndustryAnalysis.Result.Assets" /></th></tr></tbody>
                        <tbody>{hasData && headerData.renderHeader()}</tbody>
                        <tbody>{hasData && headerData.renderLabels()}</tbody>
                        <tbody>{hasData && this.renderBody(year, assets)}</tbody>
                    </table>
                </HorizontalScrollControl>
                <HorizontalScrollControl>
                    <table className="table table-report-section-2-industry-analysis without-hover w-100">
                        <tbody><tr><th colSpan="13" className="result-table-title"><Translate id="IndustryAnalysis.Result.Liabilities" /></th></tr></tbody>
                        <tbody>{hasData && headerData.renderHeader()}</tbody>
                        <tbody>{hasData && headerData.renderLabels()}</tbody>
                        <tbody>{hasData && this.renderBody(year, liabilities)}</tbody>
                    </table>
                </HorizontalScrollControl>
                <HorizontalScrollControl withMarginBottom>
                    <table className="table table-report-section-2-industry-analysis without-hover w-100">
                        <tbody><tr><th colSpan="13" className="result-table-title"><Translate id="IndustryAnalysis.Result.ProfitAndLoss" /></th></tr></tbody>
                        <tbody>{hasData && headerData.renderHeader()}</tbody>
                        <tbody>{hasData && headerData.renderLabels()}</tbody>
                        <tbody>{hasData && this.renderBody(year, profitAndLoss)}</tbody>
                    </table>
                </HorizontalScrollControl>
            </>
        );
    }

    renderBody(year, body) {
        if (!isNullOrUndefined(body) && body.length !== 0) {
            return body.map((item, key) =>
                new IndustryAnalysisReportTableBodyItem(industryAnalysisReportType.structuralIndicators, year, item).renderBodyItem(key)
            );
        }
    }

    componentDidMount() {
        this.props.getStructuralIndicators(this.props.year, this.props.nace);
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language)
            this.props.getStructuralIndicators(this.props.year, this.props.nace);
    }
}

export default connect(
    state => ({ industryAnalysis: state.industryAnalysis }),
    dispatch => bindActionCreators(industryAnalysisActions, dispatch)
)(IndustryAnalysisStructuralIndicatorsResult);